<template>
  <div class="queue queue_red" v-if="client">
    <div class="queue__wrapper">
      <div class="queue__item">
        <div class="queue__text queue__text_big">
          МТС
        </div>
      </div>
      <div class="queue__item">
        <div class="queue__text">
          {{ $t('client.number') }}
        </div>
        <div class="queue__text queue__text_big">
          {{ client.number }}
        </div>
      </div>
      <div class="queue__item">
        <div class="queue__text">
          {{ $t('client.before.title') }}
        </div>
        <div class="queue__text">
          {{ client.beforePeoples }} {{ $t('client.before.suffix') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex'

export default {
  name: 'ClientInfo',
  computed: {
    ...mapState({
      client: state => state.app.client
    })
  }
}
</script>
